import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Form, InputNumber, Switch } from 'antd';
import { UploadFileArea } from './upload-audio-file-area.component';
import { useEffect, useRef, useState } from 'react';
import { AppModal, Heading3, PrimaryButton, SecondaryButton } from '@lib/common';
import { AudioFileEdit } from '../../../form-components/src/audio-file';
import styled from 'styled-components';
import { AudioFileNumberOfReplays, Size } from '@module/form'; // TODO: remove it when the modal sizes are defined in the design system

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MODAL_SIZE = 750;
var StyledForm = styled(Form).withConfig({
  displayName: "upload-audio-file-modalcomponent__StyledForm",
  componentId: "sc-1by0n91-0"
})(["margin-top:16px;.ant-form-item{margin-bottom:14px;}.ant-form-item-label > label{height:auto;line-height:1.4;}.ant-form-item-extra{margin-top:8px;line-height:1.45;max-width:100%;}"]);
/** Switch + replay count stay on one line; wraps on very narrow viewports. */

var ReplayControlsRow = styled.div.withConfig({
  displayName: "upload-audio-file-modalcomponent__ReplayControlsRow",
  componentId: "sc-1by0n91-1"
})(["display:flex;flex-wrap:wrap;align-items:center;gap:12px;"]);
var formItemLayout = {
  labelCol: {
    span: 9
  },
  wrapperCol: {
    span: 15
  }
};
var defaultAudioRuleFormValues = {
  isAllowedToReplay: true,
  numberOfReplays: AudioFileNumberOfReplays.min.value,
  allowingToPauseAndStop: false,
  isAutoPlay: false
};
export var UploadAudioModal = function UploadAudioModal(props) {
  var isOpen = props.isOpen,
      file = props.file,
      onSave = props.onSave,
      isSavingFile = props.isSavingFile,
      isMultiple = props.isMultiple,
      label = props.label,
      isUploading = props.isUploading,
      onCancel = props.onCancel,
      _props$minNumberOfRep = props.minNumberOfReplays,
      minNumberOfReplays = _props$minNumberOfRep === void 0 ? 1 : _props$minNumberOfRep,
      _props$shouldShowAuto = props.shouldShowAutoPlayInput,
      shouldShowAutoPlayInput = _props$shouldShowAuto === void 0 ? false : _props$shouldShowAuto,
      acceptTypes = props.acceptTypes;
  var audioPlayerRef = useRef(null);

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var _useState = useState(true),
      isFirstRender = _useState[0],
      setIsFirstRender = _useState[1]; // Keep local file to reduce redundant uploaded file
  // Only upload the new one if localFile here change.


  var _useState2 = useState(true),
      shouldShowReplayInput = _useState2[0],
      setReplayInputVisibility = _useState2[1];

  var _useState3 = useState(),
      localFile = _useState3[0],
      setLocalFile = _useState3[1];

  var _useState4 = useState(false),
      isRemoteFileDeleted = _useState4[0],
      setIsRemoteFileDeleted = _useState4[1];

  var _useState5 = useState(''),
      fileName = _useState5[0],
      setFileName = _useState5[1];

  useEffect(function () {
    if (localFile || file) {
      if (localFile) {
        setFileName(localFile.name);
      } else {
        setFileName(file.name);
      }
    } else {
      setFileName('');
    }
  }, [file, localFile]);

  var beforeUpload = function beforeUpload(file) {
    setLocalFile(file);
  };

  var onDeleteFile = function onDeleteFile() {
    if (file) {
      setIsRemoteFileDeleted(true);
    }

    setLocalFile(undefined);
  };

  useEffect(function () {
    if (isOpen && !file) {
      form.resetFields();
      setReplayInputVisibility(true);
    }

    if (!isOpen) {
      var _audioPlayerRef$curre;

      setLocalFile(null);
      setIsFirstRender(true);
      setIsRemoteFileDeleted(false);
      setFileName('');
      (_audioPlayerRef$curre = audioPlayerRef.current) === null || _audioPlayerRef$curre === void 0 ? void 0 : _audioPlayerRef$curre.pause();
      form.resetFields();
    }
  }, [isOpen]);
  useEffect(function () {
    if (isFirstRender) {
      if (file) {
        var _file$rule$isAllowedT, _file$rule, _file$rule$numberOfRe, _file$rule$allowingTo, _file$rule$isAutoPlay, _file$rule2;

        var isReplayLimited = (_file$rule$isAllowedT = file.rule.isAllowedToReplay) !== null && _file$rule$isAllowedT !== void 0 ? _file$rule$isAllowedT : false;
        var rawReplays = (_file$rule = file.rule) === null || _file$rule === void 0 ? void 0 : (_file$rule$numberOfRe = _file$rule.numberOfReplays) === null || _file$rule$numberOfRe === void 0 ? void 0 : _file$rule$numberOfRe.value;
        var numberOfReplays = isReplayLimited && rawReplays != null && rawReplays !== AudioFileNumberOfReplays["default"].value ? rawReplays : AudioFileNumberOfReplays.min.value;
        form.setFieldsValue({
          isAllowedToReplay: isReplayLimited,
          numberOfReplays: isReplayLimited ? numberOfReplays : undefined,
          allowingToPauseAndStop: (_file$rule$allowingTo = file.rule.allowingToPauseAndStop) !== null && _file$rule$allowingTo !== void 0 ? _file$rule$allowingTo : false,
          isAutoPlay: (_file$rule$isAutoPlay = (_file$rule2 = file.rule) === null || _file$rule2 === void 0 ? void 0 : _file$rule2.isAutoPlay) !== null && _file$rule$isAutoPlay !== void 0 ? _file$rule$isAutoPlay : false
        });
        setReplayInputVisibility(isReplayLimited);
      } else {
        form.resetFields();
        setReplayInputVisibility(true);
      }

      setIsFirstRender(false);
    }
  }, [isFirstRender, file]);

  var onFieldChanges = function onFieldChanges(fields) {
    if (!(fields !== null && fields !== void 0 && fields.length)) return;
    var _fields$ = fields[0],
        name = _fields$.name,
        value = _fields$.value;

    if (name !== null && name !== void 0 && name.some(function (item) {
      return item === 'isAllowedToReplay';
    })) {
      setReplayInputVisibility(value);

      if (!value) {
        form.setFieldsValue({
          numberOfReplays: undefined
        });
      } else {
        var current = form.getFieldValue('numberOfReplays');

        if (current == null || current < minNumberOfReplays) {
          form.setFieldsValue({
            numberOfReplays: AudioFileNumberOfReplays.min.value
          });
        }
      }
    }
  };

  var onSaveAudioFile = function onSaveAudioFile() {
    try {
      form.validateFields();
    } catch (err) {
      return;
    }

    var _form$getFieldsValue = form.getFieldsValue(),
        numberOfReplays = _form$getFieldsValue.numberOfReplays,
        allowingToPauseAndStop = _form$getFieldsValue.allowingToPauseAndStop,
        isAllowedToReplay = _form$getFieldsValue.isAllowedToReplay,
        isAutoPlay = _form$getFieldsValue.isAutoPlay;

    onSave({
      isRemoteFileDeleted: isRemoteFileDeleted,
      numberOfReplays: isAllowedToReplay ? numberOfReplays : undefined,
      allowingToPauseAndStop: allowingToPauseAndStop,
      localFile: localFile,
      isAllowedToReplay: isAllowedToReplay,
      isAutoPlay: isAutoPlay
    });
  };

  var renderFooter = function renderFooter() {
    var buttons = [/*#__PURE__*/_jsx(SecondaryButton, {
      onClick: onCancel,
      disabled: isSavingFile,
      size: "middle",
      children: label.cancel
    }, 'cancel')];

    if (file || localFile) {
      buttons.push( /*#__PURE__*/_jsx(PrimaryButton, {
        size: "middle",
        disabled: isRemoteFileDeleted && !localFile || isSavingFile,
        loading: isSavingFile,
        onClick: onSaveAudioFile,
        children: label.save
      }, "save"));
    }

    return buttons;
  };

  return /*#__PURE__*/_jsxs(AppModal, {
    open: isOpen,
    centered: true,
    title: null,
    closable: true,
    destroyOnClose: true,
    onCancel: onCancel,
    width: MODAL_SIZE,
    footer: renderFooter(),
    children: [/*#__PURE__*/_jsx(Heading3, {
      children: label.header
    }), file && !isRemoteFileDeleted || localFile ? /*#__PURE__*/_jsx(AudioFileEdit, {
      source: localFile && URL.createObjectURL(localFile) || file.url,
      onDelete: onDeleteFile,
      fileName: fileName,
      label: {
        deleteTitle: label.deleteTitle,
        deleteOk: label.deleteOk,
        deleteCancel: label.deleteCancel
      },
      fileSize: Size.format((localFile === null || localFile === void 0 ? void 0 : localFile.size) || file.size)
    }) : /*#__PURE__*/_jsx(UploadFileArea, {
      isUploading: isUploading,
      isMultiple: isMultiple,
      acceptTypes: acceptTypes,
      label: {
        dragToUpload: label.uploadFileAreaLabel.dragToUpload,
        uploadButtonLabel: label.uploadFileAreaLabel.uploadButtonLabel,
        type: label.uploadFileAreaLabel.type,
        size: label.uploadFileAreaLabel.size,
        uploading: label.uploadFileAreaLabel.uploading
      },
      onBeforeUpload: beforeUpload
    }), /*#__PURE__*/_jsxs(StyledForm, _objectSpread(_objectSpread({
      form: form,
      layout: "horizontal"
    }, formItemLayout), {}, {
      labelAlign: "left",
      colon: true,
      onFieldsChange: onFieldChanges,
      initialValues: defaultAudioRuleFormValues,
      children: [/*#__PURE__*/_jsx(Form.Item, {
        label: label.allowReplays,
        extra: label.allowReplaysHint,
        children: /*#__PURE__*/_jsxs(ReplayControlsRow, {
          children: [/*#__PURE__*/_jsx(Form.Item, {
            name: "isAllowedToReplay",
            valuePropName: "checked",
            noStyle: true,
            children: /*#__PURE__*/_jsx(Switch, {})
          }), shouldShowReplayInput && /*#__PURE__*/_jsx(Form.Item, {
            name: "numberOfReplays",
            noStyle: true,
            children: /*#__PURE__*/_jsx(InputNumber, {
              placeholder: "99+",
              min: minNumberOfReplays,
              style: {
                width: 88
              },
              controls: true
            })
          })]
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: label.allowPauseAndStop,
        name: "allowingToPauseAndStop",
        valuePropName: "checked",
        children: /*#__PURE__*/_jsx(Switch, {})
      }), shouldShowAutoPlayInput && /*#__PURE__*/_jsx(Form.Item, {
        label: label.autoPlay,
        name: "isAutoPlay",
        valuePropName: "checked",
        children: /*#__PURE__*/_jsx(Switch, {})
      })]
    }))]
  });
};